import ReactGA from 'react-ga4';

// Replace with your GA4 measurement ID
const MEASUREMENT_ID = 'G-RW3K8520R0';

// Initialize GA4
export const initGA = () => {
  ReactGA.initialize(MEASUREMENT_ID);
};

// Track page views
export const trackPageView = (path: string) => {
  ReactGA.send({ hitType: 'pageview', page: path });
};

// Track custom events
export const trackEvent = (category: string, action: string, label?: string, value?: number) => {
  ReactGA.event({
    category,
    action,
    label,
    value
  });
};